export default __webpack_public_path__ + "assets/f45221a9a8fc66c4bf364cd79eae6e3f.png";